import React from 'react';

/*
 * "Recovery tree" brand mark — cyan canopy with orange roots.
 */
const RecoveryTreeLogo = ({width = 42, height = 44}) => (
    <svg width={width} height={height} viewBox="0 0 80 84" fill="none" aria-hidden="true">
        <path d="M40 76 L40 44" stroke="#06b6d4" strokeWidth="4" strokeLinecap="round"/>
        <path d="M40 54 C30 48,18 44,12 34" stroke="#06b6d4" strokeWidth="3" strokeLinecap="round" fill="none"/>
        <path d="M40 54 C50 48,62 44,68 34" stroke="#06b6d4" strokeWidth="3" strokeLinecap="round" fill="none"/>
        <path d="M40 44 L40 16" stroke="#06b6d4" strokeWidth="3" strokeLinecap="round"/>
        <path d="M12 34 C8 24,10 16,16 10" stroke="#06b6d4" strokeWidth="2" strokeLinecap="round" fill="none"/>
        <path d="M12 34 C6 30,4 24,8 18" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.6"/>
        <path d="M68 34 C72 24,70 16,64 10" stroke="#06b6d4" strokeWidth="2" strokeLinecap="round" fill="none"/>
        <path d="M68 34 C74 30,76 24,72 18" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.6"/>
        <path d="M40 22 C34 16,28 10,24 6" stroke="#06b6d4" strokeWidth="2" strokeLinecap="round" fill="none"/>
        <path d="M40 22 C46 16,52 10,56 6" stroke="#06b6d4" strokeWidth="2" strokeLinecap="round" fill="none"/>
        <path d="M40 76 C32 80,20 82,12 78" stroke="#f97316" strokeWidth="2" strokeLinecap="round" fill="none"/>
        <path d="M40 76 C48 80,60 82,68 78" stroke="#f97316" strokeWidth="2" strokeLinecap="round" fill="none"/>
        <path d="M40 76 C38 82,36 84,34 82" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.6"/>
    </svg>
);

export default RecoveryTreeLogo;
